module.exports = __webpack_public_path__ + "static/media/hdi-minus.a9faa6fd.svg";